import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import DataTable from "react-data-table-component";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import {
  getEdudexList,
  GetCommonContentCancelToken
} from "../../../services/RegistrationService";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Str from "../../common/Str";
import Tablefilter from "../../common/Tablefilter";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";
import hasPermission from "../../../utils/hasMultiplePermission";
import Swal from "sweetalert2";


const HEQCIS_Table = () => {
  const [loading, setloading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [intakeYear, setIntakeYear] = useState({ arr: [], checkObj: {} });
  const [intakeNumber, setIntakeNumber] = useState({ arr: [], checkObj: {} });
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [intakeYearOptions, setIntakeYearOptions] = useState([]);
  const [intakeNumberOptions, setIntakeNumberOptions] = useState([]);
  
  const givenPermsisions = useSelector((state) => state.givenPermission)
  
  useEffect(() => {
    const source = axios.CancelToken.source();
    
    const getCommonContent = async () => {
      try {
        const res = await GetCommonContentCancelToken(source.token);
        if (res.status === 200) {
          res?.data?.intake_year && setIntakeYearOptions(res.data.intake_year);
          res?.data?.intake_number && setIntakeNumberOptions(res.data.intake_number);
        }
      } catch (error) {
        if (!axios.isCancel(error)) console.error(error);
      }
    };
    
    getCommonContent();
    
    return () => {
      source.cancel('Component unmounted');
    };
  }, []);
  
  useEffect(() => {
    let response = hasPermission({
      scopes: ["heqcis"],
      permissions: givenPermsisions,
    });
    if (!response) {
      window.location.href = "/noaccess";
    }
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 1000);
    return () => clearTimeout(handler);
  }, [search]);
  
  useEffect(() => {
    handleTableScroll()
  }, [loading])
  useEffect(() => {
    const cancelTokenSources = [];
    
    const getData = async() => {
      setloading(true)
      
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
      
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      
      let data = {
        page,
        limit: perPage,
        search: debouncedSearch,
        intakeYear: intakeYear.arr,
        intakeNumber: intakeNumber.arr,
        isExport: 0,
      }
      try {
        const res = await getEdudexList(data, source.token);
        setTotalRows(res.data.total)
        setPage(res.data.page)
        setPerPage(res.data.perPage)
        setStudentList(res && res.data && res.data.data ? res.data.data : []);
        if (res.status === 200) {
          setloading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    }
    
    getData();
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [page, perPage, intakeYear, intakeNumber,debouncedSearch]);
  
  
  const columns = useMemo(() => [
    {
      name: "Student Number",
      selector: "Student Number",
      sortable: false,
      cell: (row) => (
        <a
        className="as-text-blue curser feature-name"
        title={row.description}
        target="_blank"
        href={row['AMI LINK']}
        >
        <span className="textLimit100" title={row['Student Number']}>{row['Student Number'] ??  "-"}</span>
        </a>
      ),
    },
    {
      name: 'Title',
      selector: 'title',
      sortable: 'false',
      cell: (row) => (
        <span className="textLimit100" title={row.title}>{row.title ?? "-"}</span> // todo, hyperlink to AMI LINK
      )
    },
    {
      name: "First Name",
      selector: "first_name",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.first_name}>{row.first_name ?? "-"}</span>
      ),
    },
    {
      name: "Second Name",
      selector: "second_name",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.second_name}>{row.second_name ?? "-"}</span>
      ),
    },
    {
      name: "Third Name",
      selector: "third_name",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.third_name}>{row.third_name ?? "-"}</span>
      ),
    },
    {
      name: "Lastname",
      selector: "last_name",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.last_name}>{row.last_name ?? "-"}</span>
      ),
    },
    {
      name: "email",
      selector: "email",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.email}>{row.email ?? "-"}</span>
      ),
    },
    {
      name: "Mobile",
      selector: "mobile",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.mobile}>{row.mobile ?? "-"}</span>
      ),
    },
    {
      name: "Nationality",
      selector: "nationality",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.nationality}>{row.nationality ?? "-"}</span>
      ),
    },
    {
      name: "Gender",
      selector: "gender",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.gender}>{row.gender ?? "-"}</span>
      ),
    },
    {
      name: "Race",
      selector: "race",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.race}>{row.race ?? "-"}</span>
      ),
    },
    {
      name: "RSA ID/Passport",
      selector: "RSA ID/Passport",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title ={row['RSA ID/Passport']}>{row['RSA ID/Passport'] ?? "-"}</span>
      ),
    },
    {
      name: "Disability",
      selector: "disability",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row.disability}>{row.disability ?? "-"}</span>
      ),
    },
    {
      name: "Date Of Birth",
      selector: "Date Of Birth",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100">{row['Date Of Birth'] ??  "-"}</span>
      ),
    },
    {
      name: "Street",
      selector: "ph_street",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['ph_street']}>{row['ph_street'] ??  "-"}</span>
      ),
    },
    {
      name: "City",
      selector: "ph_city",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['ph_city']}>{row['ph_city'] ??  "-"}</span>
      ),
    },
    {
      name: "Province",
      selector: "ph_province",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['ph_province']}>{row['ph_province'] ??  "-"}</span>
      ),
    },
    {
      name: "Province Code",
      selector: "Province Code",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100">{row['Province Code'] ??  "-"}</span>
      ),
    },
    {
      name: "Country",
      selector: "ph_country",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['ph_country']}>{row['ph_country'] ??  "-"}</span>
      ),
    },
    {
      name: "Zip Code",
      selector: "ph_zip",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['ph_zip']}>{row['ph_zip'] ??  "-"}</span>
      ),
    },
    {
      name: "Intake",
      selector: "Intake",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['Intake']}>{row['Intake'] ??  "-"}</span>
      ),
    },
    {
      name: "Programme Type",
      selector: "Programme Type",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['Programme Type']}>{row['Programme Type'] ??  "-"}</span>
      ),
    },
    {
      name: "Qualification",
      selector: "Qualification",
      sortable: false,
      cell: (row) => (
        <span className="textLimit100" title={row['Qualification']}>{row['Qualification'] ??  "-"}</span>
      ),
    },
    {
      name: "School",
      selector: "School Type",
      sortField: "School Type",
      sortable: false,
      cell: (row) => <span className = 'textLimit100' title={row['School Type']}>{row['School Type'] ?? "-"}</span>
    },
    {
      name: "Brand",
      selector: "Brand",
      sortField: "Brand",
      sortable: false,
      cell: (row) => <span className = 'textLimit100' title={row['Brand']}>{row['Brand'] ?? "-"}</span>
    },
    {
      name: "Action",
      selector: "",
      cell: (row) => (
        <div className="assessment-08">
        <div className="as-buttons">
        <a
        target="_blank"
        href={row['AMI LINK']}
        >
        <button title="Open" className="btn btn-primary rounded-circle">
        <i className="fal fa-folder-open"></i>
        </button>
        </a>
        </div>
        </div>
      ),
    },
  ]);
  
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };
  
  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };
  
  const handleFilters = (e, type = "") => {
    const value = e.target.value;
    if (type === "search") {
      setSearch(value);
    }
  };
  
  function resetFilter() {
    setSearch("");
    setIntakeYear({ arr: [], checkObj: {} })
    setIntakeNumber({ arr: [], checkObj: {} })
  }
  
  const exportData = (fileType, fileName) => {
    
    let data = {
      page,
      limit: perPage,
      search: debouncedSearch,
      intakeYear: intakeYear.arr,
      intakeNumber: intakeNumber.arr,
      isExport: 1,
    }
    Swal.fire({
      icon: "info",
      title: "Downloading...",
      onOpen: function () {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false
    })
    getEdudexList(data)
    .then((res) => {
      let data = res?.data || {}
      const header = [
        "Student Number",
        "Title",
        "First Name",
        "Second Name",
        "Third Name",
        "Lastname",
        "email",
        "Mobile",
        "Nationality",
        "Gender",
        "Race",
        "RSA ID/Passport",
        "Disability",
        "Date Of Birth",
        "Street",
        "City",
        "Province",
        "Province Code",
        "Country",
        "Zip Code",
        "Intake",
        "Programme Type",
        "Qualification",
        "School",
        "Brand",
      ];
      data = data?.map((row) => ({
        ...row,
        'Student Number': row["Student Number"],
        'Title': row['title'],
        'First Name': row["first_name"],
        'Second Name': row["second_name"],
        'Third Name': row["third_name"],
        'Lastname': row["last_name"],
        'email': row["email"],
        'Mobile': row["mobile"],
        'Nationality': row["nationality"],
        'Gender': row["gender"],
        'Race': row["race"],
        'RSA ID/Passport': row["RSA ID/Passport"],
        'Disability': row["disability"],
        'Date Of Birth': row["Date Of Birth"],
        'Street': row["ph_street"],
        'City': row["pg_city"],
        'Province': row["ph_province"],
        'Province Code': row["Province Code"],
        'Country': row["ph_country"],
        'Zip Code': row["ph_zip"],
        'Intake': row["Intake"],
        'Programme Type': row["Programme Type"],
        'Qualification': row["Qualification"],
        'School': row["School Type"],
        'Brand': row["Brand"],
      }));
      if (fileType === "csv") {
        const csvString = Papa.unparse({ fields: header, data });
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });
        
        const blobURL = window.URL.createObjectURL(blob);
        
        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
          "text/csv",
          anchor.download,
          anchor.href,
        ].join(":");
        anchor.click();
        
        setTimeout(() => {
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        const compatibleData = data.map((row) => {
          const obj = {};
          header.map((col, index) => {
            obj[col] = row[col];
          });
          return obj;
        });
        
        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        return false;
      }
      if (fileType === "pdf") {
        const compatibleData = data.map((row) => {
          return [
            row["Student Number"],
            row['title'],
            row["first_name"],
            row["second_name"],
            row["third_name"],
            row["last_name"],
            row["email"],
            row["mobile"],
            row["nationality"],
            row["gender"],
            row["race"],
            row["RSA ID/Passport"],
            row["disability"],
            row["Date Of Birth"],
            row["ph_street"],
            row["pg_city"],
            row["ph_province"],
            row["Province Code"],
            row["ph_country"],
            row["ph_zip"],
            row["Intake"],
            row["Programme Type"],
            row["Qualification"],
            row["School Type"],
            row["Brand"  ],
          ];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            minCellWidth: 5,
            halign: "left",
            fontSize: 8,
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }
      
    })
    .catch((error) => {
      console.error("error :", error);
      Swal.close();
    });
    
  };
  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
    <div className="search-filter-div">
    <div className="search-filter-div-left">
    <div className="system-administration-table table-responsive">
    <div className="table-responsive-div">
    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer" >
    <div id="assessment-table-main_filter" className="dataTables_filter" >
    <label>
    <input type="search" className="" placeholder="Search" aria-controls="assessment-table-main" onChange={(e) => handleFilters(e, "search")} value={search} />
    </label>
    <div className="filter-eff filter-data-btn">
    <button className="filter-buttons">
    <i className="fal fa-filter"></i>
    </button>
    </div>
    </div>
    </div>
    </div>
    <div className="filter-button-group">
    <div className="filter-scroll">
    <div className={`filter-scroll-inner  filter-custom-new`}>
    <Tablefilter
    filterName={"Intake Year"}
    optionArr={intakeYearOptions}
    state={intakeYear}
    setState={setIntakeYear}
    isOptionReversed={true}
    
    />
    <Tablefilter
    filterName={"Intake Number"}
    optionArr={intakeNumberOptions}
    state={intakeNumber}
    setState={setIntakeNumber}
    isOptionReversed={false}
    />
    </div>
    </div>
    <div className="reset-btn-group">
    <div className="button-reset dropdown-comman">
    <button className="btn btn-primary" title="Reset" onClick={resetFilter} >
    <i className="fal fa-redo"></i>Reset
    </button>
    </div>
    <div className="files-export-group">
    <button type="button" className="btn btn-files" onClick={() => { exportData("xlsx", "E-Books export list"); }} title="Export spreadsheet" >
    <i className="fal fa-file-excel icon"></i>
    </button>
    <button type="button" className="btn btn-files" onClick={() => { exportData("csv", "E-Books export list"); }} title="Export CSV" >
    <i className="fal fa-file-csv icon"></i>
    </button>
    <button type="button" className="btn btn-files" onClick={() => { exportData("pdf", "E-Books export list"); }} title="Export PDF" >
    <i className="fal fa-file-pdf icon"></i>
    </button>
    </div>
    </div>
    </div>
    
    </div>
    </div>
    </div>
    <DataTable
    data={studentList}
    defaultSortField="created_date"
    defaultSortAsc={false}
    columns={columns}
    pagination={true}
    onSort={() => {}}
    noDataComponent={Str.noRecord}
    paginationServer
    sortServer
    paginationTotalRows={totalRows}
    onChangeRowsPerPage={handlePerRowsChange}
    onChangePage={handlePageChange}
    highlightOnHover={false}
    progressPending={loading}
    progressComponent={<SkeletonTicketList />}
    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
    />
    </div>
    </div>
  );
};

export default HEQCIS_Table;
